export class RejectAcceptTransfer {
  stockTransferId: number;
  userId: string;
}
